import {createStateMaker} from '@shared/helpers/object'

import {VoucherState} from '../interfaces'

export const getInitialState = (): VoucherState => ({
    cultureLand: {
        loginId: '',
        loginPassword: '',
        loginSuccessId: '',
        balance: null,
        certNo: '',
        custId: '',
        sid: '',
        tid: '',
        billing: {
            pgCp: '',
            pgId: '',
            minimumAmount: null,
            maximumAmount: null,
        },
    },
    happyMoney: {
        loginId: '',
        loginPassword: '',
        loginSuccessId: '',
        balance: null,
        certNo: '',
        custId: '',
        sid: '',
        tid: '',
        billing: {
            pgCp: '',
            pgId: '',
            minimumAmount: null,
            maximumAmount: null,
        },
    },
})

export const makeMock = createStateMaker<VoucherState>(getInitialState)
